//@flow strict
import * as React from 'react';
import {LinearLoader} from '@spaced-out/ui-design-system/lib/components/LinearLoader';
import {CircularLoader} from '@spaced-out/ui-design-system/lib/components/CircularLoader';
import Logo from 'src/images/sense-logo.svg';

import css from './fullscreen-loader.css';


export const FullscreenLoader = ({
  description,
  loaderType = 'linear',
  showLogo = true,
}: {
  description?: React.Node,
  loaderType?: 'linear' | 'circular',
  showLogo?: boolean,
}): React.Node => (
  <div className={css.loadingContainer}>
    {showLogo && <Logo className={css.logo} />}
    {loaderType === 'linear' ? (
      <LinearLoader
        className={css.loader}
        value={100}
        size="medium"
        indeterminate
      />
    ) : (
      <CircularLoader
        className={css.circularLoader}
        colorToken="colorFillPrimary"
        size="large"
      />
    )}
    <div className={css.description}>{description}</div>
  </div>
);
